import React from "react";
import "./style.scss";

const Layout = ({ children, bg, step, startQuiz }) => {
  return (
    <div className={`layout ${step > 0 ? "startQuiz" : ""}`}>{children}</div>
  );
};

export default Layout;
